// test1370
(1370 && 0);
